import {h, Fragment} from "preact"
import { colorFacet } from '../../config'

export default function ColorFilters({ facet, toggleProductFilter }) {
    // console.log(facet);
    return (
        <ul class="ns-filters-list ns-color-list" >
            {facet.data?.map(value => {
                const fieldName = facet.field.replaceAll('.', '-').replaceAll(' ', '-').toLowerCase();
                const colorName = value.value.replaceAll(' ', '-').replaceAll('\/', '-').toLowerCase();
                
                return (<li
                    class="ns-filter-item"
                    data-nosto-element="facet-setting"
                >
                    <input 
                        type="checkbox"
                        class="ns-filter-input"
                        id={`${fieldName}-${colorName}`}
                        checked={value.selected} 
                        onChange={(e) => {
                            e.preventDefault()
                            toggleProductFilter(facet.field, value.value, !value.selected)
                        }}
                    />
                    <label class="ns-filter-label" for={`${fieldName}-${colorName}`}>
                        <div class="ns-color-filter-wrapper">
                            <div 
                                class="ns-color-filter" 
                                // style={`--color-hex: ${colorFacet[value.value] || '#E5E5E5'}`}
                                style={
                                    value.visual?.type === "thumbnail"
                                      ? { backgroundImage: `url(${value.visual.value})` }
                                      : { backgroundColor: value.visual?.value || '#E5E5E5' }
                                  }
                            ></div>
                        </div>
                        <span class="ns-filter-text">
                            {value.value}
                        </span>
                    </label>
                </li>)
            })}
        </ul>
    )
}